// removed by extract-text-webpack-plugin
module.exports = {"root":"_1D4Y8qE"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SignInRegisterLink/SignInRegisterLink.less
 ** module id = 735
 ** module chunks = 0
 **/